"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBusinessName = void 0;
const BusinessNameMap = {
    pm: "photomaps.com",
    tbl: "Thunder Bunny Labs",
};
function getBusinessName(businessId) {
    return BusinessNameMap[businessId];
}
exports.getBusinessName = getBusinessName;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJCdXNpbmVzc1V0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL01hcG1ha2VyQnVzaW5lc3NVdGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLGVBQWUsR0FBbUQ7SUFDdEUsRUFBRSxFQUFFLGVBQWU7SUFDbkIsR0FBRyxFQUFFLG9CQUFvQjtDQUMxQixDQUFDO0FBRUYsU0FBZ0IsZUFBZSxDQUFDLFVBQThCO0lBQzVELE9BQU8sZUFBZSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0FBQ3JDLENBQUM7QUFGRCwwQ0FFQyJ9